import { useState } from "react";
import { Check, Copy } from "react-feather";

interface CopyCodeProps {
  code: string;
  prefix?: string;
  showIcon?: boolean;
}

export function CopyCode({
  code,
  prefix = "Code:",
  showIcon = true,
}: CopyCodeProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  return (
    <div
      className="p-2.5 bg-muted rounded-lg text-sm cursor-pointer select-none hover:bg-accent transition-colors relative group"
      onClick={handleCopy}
    >
      <div className="flex items-center justify-between gap-2">
        <span className="font-mono text-xs flex min-w-0 items-center gap-1">
          <span className="shrink-0 whitespace-nowrap">{prefix}</span>
          {/* Long codes get an ellipsis; press and hold to see the whole thing. */}
          <code
            title={code}
            className="block min-w-0 truncate font-semibold group-active:whitespace-normal group-active:break-all"
          >
            {code}
          </code>
        </span>
        {showIcon && (
          <div className="text-muted-foreground group-hover:text-muted-foreground">
            {copied ? (
              <Check size={16} className="text-green-500" />
            ) : (
              <Copy size={16} />
            )}
          </div>
        )}
      </div>
      {copied && (
        <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-gray-800 text-white text-xs py-1 px-2 rounded">
          Copied!
        </div>
      )}
    </div>
  );
}
